/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useApi from '../hooks/use-api';
import { getCompanyStudents } from '../constants/routes';
import InfoBar from '../components/Navigation/InfoBar';
import Greetings from '../components/common/Greetings';
import {
	CERTIFICATES_ENABLED,
	CODE_95_ENABLED,
	DRIVING_PASS_EXPIRY_DATE_ENABLED,
	LICENSE_EXPIRY_DATE_ENABLED,
	useViewPreferences,
} from '../hooks/view-preferences';
import { useUser } from '../hooks/use-user';
import useEstablishments from '../hooks/use-establishments';
import CertificateRisk from '../components/Tables/Dashboard/CertificateRisk/CertificateRisk';
import Code95Cycle from '../components/Tables/Dashboard/Code95Cycle/Code95Cycle';
import DrivingLicense from '../components/Tables/Dashboard/DrivingLicense/DrivingLicense';
import DrivingPass from '../components/Tables/Dashboard/DrivingPass/DrivingPass';

function DashboardPage() {
	const { activeCompany, profile } = useUser();
	const { isPreferenceOptionEnabled } = useViewPreferences();
	const [{ data, isLoading }] = useApi.get(
		getCompanyStudents(activeCompany.id),
		{ archived: false },
		{ cachePolicy: 'no-cache' },
	);
	const { t } = useTranslation();
	const [selectedEstablishmentId, setSelectedEstablishmentId] = useState(0);
	const establishmentData = useEstablishments();

	const filteredStudents = useMemo(() => {
		if (establishmentData && data?.length > 0) {
			const establishmentIds =
				selectedEstablishmentId > 0
					? [selectedEstablishmentId]
					: establishmentData.map((establishment) => establishment.id);

			return data.filter(
				(student) =>
					(selectedEstablishmentId === 0 && !student.establishment?.id) ||
					establishmentIds.includes(student.establishment?.id),
			);
		}
		return [];
	}, [selectedEstablishmentId, data, establishmentData]);

	return (
		<>
			<InfoBar />
			<div className="d-flex justify-content-center">
				<div className="col-12 mx-3">
					<div className="row p-3 ms-5 d-flex flex-row justify-content-between col-10">
						<div className="col-3">
							<Greetings />
						</div>
						{profile.companyContactPerson ? (
							<div className="col-3">
								<Form.Select
									value={selectedEstablishmentId}
									onChange={(e) => setSelectedEstablishmentId(parseInt(e.target.value, 10))}>
									<option value={0}>{t('table.allEstablishments')}</option>
									{(establishmentData || []).map((est) => (
										<option key={est.id} value={est.id}>
											{est.name}
										</option>
									))}
								</Form.Select>
							</div>
						) : null}
					</div>
					{isLoading ? (
						<div className="loading-spinner" />
					) : (
						<div className="row justify-content-start mx-5">
							{isPreferenceOptionEnabled(CERTIFICATES_ENABLED) && (
								<CertificateRisk
									selectedEstablishmentId={selectedEstablishmentId}
									establishmentData={establishmentData}
								/>
							)}
							{isPreferenceOptionEnabled(CODE_95_ENABLED) && (
								<Code95Cycle students={filteredStudents} />
							)}
							{isPreferenceOptionEnabled(LICENSE_EXPIRY_DATE_ENABLED) && (
								<DrivingLicense students={filteredStudents} />
							)}
							{isPreferenceOptionEnabled(DRIVING_PASS_EXPIRY_DATE_ENABLED) && (
								<DrivingPass students={filteredStudents} />
							)}
						</div>
					)}
				</div>
			</div>
		</>
	);
}

export default DashboardPage;
